export function formattedContent(content) {
  return content
    ? content.replace(/<p>/g, "").replace(/<\/p>/g, "").replace(/\n/g, "<br>")
    : content;
}

export async function generateUniqueId(text, uniqueIdSuffix) {
  const uniqueId = safeEncode(text).substring(0, 20) + uniqueIdSuffix;
  return uniqueId;
}

const safeEncode = (str) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  return btoa(String.fromCharCode(...data));
};